import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_DEPORTES,
  ALL_DEPORTES,
  LOADING_ALL_DEPORTES,
} from './DeportesReducer';
import {
  deleteDeportesService,
  allDeportesService,
  oneDeportesService,
  saveDeportesService,
} from './DeportesService';

export const allDeportesAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_DEPORTES, payload: true });
    const res = await allDeportesService(params);
    dispatch({ type: ALL_DEPORTES, payload: res.data });
    dispatch({ type: LOADING_ALL_DEPORTES, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_DEPORTES, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveDeportesAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveDeportesService(id, data);
    notify(res.data.message);
    await allDeportesAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoDeportesAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_DEPORTES, payload: data });
};

export const oneDeportesAction = async (dispatch, id) => {
  try {
    const res = await oneDeportesService(id);
    await setActivoDeportesAction(dispatch, res.data.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteDeportesAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteDeportesService(id);
    notify(res.data.message);
    await setActivoDeportesAction(dispatch, null);
    await allDeportesAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
